import type { NoraSettings, SessionSummary } from "../types";

interface ConversationContextBarProps {
  session: SessionSummary | null;
  projectName: string | null;
  settings: NoraSettings | null;
}

export function ConversationContextBar({ session, projectName, settings }: ConversationContextBarProps) {
  const runtime = resolveRuntime(session, settings);
  const project = projectName ?? "Aucun projet";
  const conversation = session?.title ?? "Aucune";

  return (
    <section className="conversation-context-bar" aria-label="Contexte de la conversation">
      <div className="conversation-context-topline">
        <strong className="conversation-context-project" title={`Projet : ${project}`} aria-label={`Projet : ${project}`}>
          {project}
        </strong>
        <span className="conversation-context-badges">
          <span
            className="conversation-context-badge conversation-context-model"
            title={`Modèle : ${runtime.model}`}
            aria-label={`Modèle : ${runtime.model}`}
          >
            {runtime.model}
          </span>
          <span
            className="conversation-context-badge conversation-context-effort"
            title={`Effort : ${runtime.effort}`}
            aria-label={`Effort : ${runtime.effort}`}
          >
            {runtime.effort}
          </span>
        </span>
      </div>
      <span
        className="conversation-context-conversation"
        title={`Conversation : ${conversation}`}
        aria-label={`Conversation : ${conversation}`}
      >
        {conversation}
      </span>
    </section>
  );
}

function resolveRuntime(session: SessionSummary | null, settings: NoraSettings | null): { model: string; effort: string } {
  if (!session) return { model: "--", effort: "--" };
  if (session.driverId === "demo") return { model: "Nora Démo", effort: "--" };

  const inheritsDefaults = session.modelId == null;
  const model = session.modelId ?? settings?.defaultModelId ?? "Codex par défaut";
  const reasoningEffort = session.reasoningEffort
    ?? (inheritsDefaults ? settings?.defaultReasoningEffort : null);
  return { model, effort: reasoningEffortLabel(reasoningEffort ?? null) };
}

function reasoningEffortLabel(value: string | null): string {
  switch (value) {
    case "low": return "Faible";
    case "medium": return "Moyen";
    case "high": return "Élevé";
    case "xhigh": return "Très élevé";
    case "max": return "Maximal";
    case "ultra": return "Ultra";
    default: return value ?? "Par défaut";
  }
}
